import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import { ToastContainer, toast, Slide } from 'react-toastify';
import axios from "axios";
import '../styles/MenuSettings.css';
import 'react-toastify/dist/ReactToastify.css';

export default function MenuSettings() {
    // TODO save notif settings of user
    // TODO ask user to re-input password before changing settings
    
    const notify = (type, message) => {
        const properties = {
          position: "bottom-right",
          transition: Slide,
          autoClose: 2900,
          draggable: true,
          closeOnClick: true,
          pauseOnHover: false,
        }

        if (toast[type]) {
            toast[type](message, properties); // e.g., toast.success("Success message")
        } else {
            toast(message, properties); // Default toast if type is unknown
        }

        // TODO custom css class
    }

    const formatToSQLDateTime = (isoDateTime) => {
        const date = new Date(isoDateTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit format
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = "00"; // Manually set seconds to match SQL format
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const [selectedOption, setSelectedOption] = useState('ADD DOCUMENT');
    const [documents, setDocuments] = useState([]);
    const [newDocument, setNewDocument] = useState({
        name: '',
        price: '',
        processingDays: '',
        pages: '',
        // luzon_price: '',
        // visayas_price: '',
        // mindanao_price: '',
    });

    const [shippingFees, setShippingFees] = useState({
        Luzon: 0,
        Visayas: 0,
        Mindanao: 0,
    });
    
    const [selectedRegion, setSelectedRegion] = useState('Luzon');

    const [hiddenDocuments, setHiddenDocuments] = useState([]);
    
    const [errorCMS, setErrorCMS] = useState({
        type: "",
        message: ""
    });

    const [errorDocuments, setErrorDocuments] = useState({
        type: "",
        message: ""
    });

    const [errorFees, setErrorFees] = useState({
        type: "",
        message: ""
    });

    const [errorSettings, setErrorSetttings] = useState({
        type: "",
        message: ""
    });    

    const [isEditable, setIsEditable] = useState(false); // Added state for edit toggle
    const toggleEditable = () => {
        setIsEditable((prev) => !prev);
    };

    const [entries, setEntries] = useState([]);
    const [newTitle, setNewTitle] = useState("");
    const [newGuidelines, setNewGuidelines] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editTitle, setEditTitle] = useState("");
    const [editGuidelines, setEditGuidelines] = useState("");

    const [note, setNote] = useState(""); // State for the note
    const [isEditing, setIsEditing] = useState(false); // State for edit mode
    const [error, setError] = useState(null); // State for errors
    const [successMessage, setSuccessMessage] = useState(null); // State for success messages
    
    const [courses, setCourses] = useState([]);
    const [newCourse, setNewCourse] = useState("");
    const [errorCourse, setErrorCourse] = useState("");

    const [isDeliveryEnabled, setIsDeliveryEnabled] = useState(true);

  // Fetch the delivery status from backend
    useEffect(() => {
        const fetchStatus = () => {
        axios
            .get(
            "https://docuquest-swu.swucite.tech/api_drts/shippingFee.php?fetch_delivery_status=true"
            )
            .then((response) => {
            if (response.data && response.data.delivery_status !== undefined) {
                setIsDeliveryEnabled(response.data.delivery_status === 1);
            }
            })
            .catch((error) => {
            //console.error("Error fetching delivery status:", error);
            });
        };

        fetchStatus();
        const interval = setInterval(fetchStatus, 5000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const updateDeliveryStatus = async (region, deliveryStatus) => {
        try {
        const response = await axios.post(
            "https://docuquest-swu.swucite.tech/api_drts/shippingFee.php",
            {
            region: region,
            delivery_status: deliveryStatus,
            },
            {
            headers: { "Content-Type": "application/json" },
            }
        );

        //console.log("Response:", response.data);
        } catch (error) {
        //console.error("Error updating delivery status:", error);
        }
    };

    const toggleDelivery = () => {
        const newStatus = isDeliveryEnabled ? 0 : 1;
        const txtStatus = newStatus === 1 ? "Enabled" : "Disabled";
        
        axios
        .post(
            "https://docuquest-swu.swucite.tech/api_drts/shippingFee.php",
            { region: "all", delivery_status: newStatus }, // Update ALL regions
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            //console.log("Server Response:", response.data);
            if (response.data.message) {
            setIsDeliveryEnabled(newStatus === 1);
            } else {
            //console.error("Update failed:", response.data.error);
            }
        })
        .catch((error) => {
            //console.error("Error updating delivery status:", error);
        });

        const today = new Date();

        axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
            updated_by: userIdRef.current,
            updated_date: formatToSQLDateTime(today),
            created_by: userIdRef.current,
            created_date: formatToSQLDateTime(today),
            feedback: `Delivery Service: ${txtStatus}`,
            name_action: "Delivery Enable/Disable",
            status_action: `Delivery ${txtStatus} by ${userNameRef.current}`,
            stage_now: 1,
            stage_max: 1,
            score_eff: 0.5,
            score_prod: 0.7
        })
        .then(() => {
                        
        })
        .catch((err) => {
    
        })

        notify("warning", `Delivery service: ${txtStatus}`);
    };

    // TODO use confirm modal instead of window confirm
    const handleDeleteCourse = async (id) => {
        if (window.confirm("Are you sure you want to delete this course?")) {
            try {
                const response = await axios.delete(`https://docuquest-swu.swucite.tech/api_drts/courses.php?id=${id}`, {
                    headers: { "Content-Type": "application/json" },
                });
    
                if (response.data.status === "success") {
                    const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `Course ${id} deleted`,
                        name_action: "Course Delete",
                        status_action: `Course celeted by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 0.5,
                        score_prod: 0.7
                    })
                    .then(() => {
                                    
                    })
                    .catch((err) => {
                
                    }) 

                    setCourses(courses.filter((course) => course.id !== id)); // Update the state
                } else {
                    alert(`Error: ${response.data.message}`);
                }
            } catch (error) {
                //console.error("Error deleting course:", error);
                alert("Error deleting course. Please check the console for details.");
            }
        }
    };

    const handleAddCourse = async () => {
        if (!newCourse.trim()) {
            notify("warning", `Course name cannot be empty`);
            setErrorCourse("Course name cannot be empty.");
            return;
        }
    
        try {
            const response = await axios.post(
                "https://docuquest-swu.swucite.tech/api_drts/courses.php",
                { course_name: newCourse },
                { headers: { "Content-Type": "application/json" } }
            );
    
            if (response.data.status === "success") {
                setNewCourse("");
                setErrorCourse("");
                notify("success", `New course ${newCourse} added`);
                
                const today = new Date();

                axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                    updated_by: userIdRef.current,
                    updated_date: formatToSQLDateTime(today),
                    created_by: userIdRef.current,
                    created_date: formatToSQLDateTime(today),
                    feedback: `New course: ${newCourse}`,
                    name_action: "Course Add",
                    status_action: `Course added by ${userNameRef.current}`,
                    stage_now: 1,
                    stage_max: 1,
                    score_eff: 0.5,
                    score_prod: 0.7
                })
                .then(() => {
                                
                })
                .catch((err) => {
            
                })  
                
                fetchCourses(); // Refresh the courses list
            } else {
                setErrorCourse(response.data.message);
            }
        } catch (error) {
            setErrorCourse("Error adding course. Please check the console for details.");
            //console.error(error);
        }
    };

    const fetchCourses = async () => {
        try {
            const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/courses.php");
            if (response.data.status === "success") {
                setCourses(response.data.courses);
            } else {
                setErrorCourse(response.data.message);
            }
        } catch (error) {
            setErrorCourse("Error fetching courses. Please check the console for details.");
            //console.error(error);
        }
    };

    const navigate = useNavigate();
    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState('');
    const userIdRef = useRef('');
    const userNameRef = useRef('');
    useEffect(() => {
        document.title = "Settings";

        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
        .then((res) => {
          // console.warn("is the session alive in singlerequest? ", res.data);
          if (res.data.status === 1) {
              userIdRef.current = res.data.id;
              userNameRef.current = res.data.fullname;
              setUserId(res.data.id);
              setUserName(res.data.fullname);
          } 
        })
        .catch((err) => {
          //console.error("ERROR: Your session cannot be found!", err);
  
        });  


        fetchCourses();

        // Fetch the note from the backend
        const fetchNote = async () => {
            try {
                const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/note.php");
                if (response.data.status === "success") {
                    setNote(response.data.note);
                } else {
                    setError(response.data.message);
                }
            } catch (error) {
                setError("Error fetching note. Please check the console for details.");
                //console.error(error);
            }
        };

        // Fetch info and guidelines entries from backend  
        const fetchEntries = async () => {
            try {
                const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/documentGuidelines.php");
                if (response.data.status === "success" && Array.isArray(response.data.data)) {
                    setEntries(response.data.data);
                } else {
                    setEntries([]); // Fallback to an empty array
                    alert("Error fetching data: " + (response.data.message || "Unknown error"));
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
                setEntries([]); // Fallback to an empty array in case of error
                alert("Error fetching data. Check console for details.");
            }
        };

        fetchEntries();
        fetchNote();
    }, []);

    const handleAddEntry = () => {
        if (!newTitle.trim() || !newGuidelines.trim()) {
            notify("warning", `Both title and guidelines are required.`);
            alert("Both title and guidelines are required.");
            return;
        }

        axios
            .post(
                "https://docuquest-swu.swucite.tech/api_drts/documentGuidelines.php",
                { title: newTitle, guidelines: newGuidelines },
                { headers: { "Content-Type": "application/json" } }
            )
            .then((response) => {
                if (response.data.status === "success") {
                    const newEntry = {
                        id: response.data.data.id, // Backend now returns the ID in `data`
                        title: newTitle,
                        guidelines: newGuidelines,
                        created_at: new Date().toISOString(),
                    };                    
                    setEntries([newEntry, ...entries]); // Update entries on the page
                    setNewTitle("");
                    setNewGuidelines("");
                    notify("success", `Added new section \"${newEntry}\" to guidelines`);
                    
                    const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `New entry: ${newTitle}`,
                        name_action: "Guidelines&Policies New Entry" ,
                        status_action: `Entry added by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 0.5,
                        score_prod: 0.7
                    })
                    .then(() => {
                                    
                    })
                    .catch((err) => {

                    })  
                    
                    alert(response.data.message); // Show success message
                } else {
                    alert("Failed to save entry: " + response.data.message);
                }
            })
            .catch((error) => {
                //console.error("Error saving entry:", error);
                alert("Error saving entry. Check console for details.");
            });
    };

    // Enable edit mode
    const handleEdit = (entry) => {
        setEditingId(entry.id);
        setEditTitle(entry.title);
        setEditGuidelines(entry.guidelines);
    };

    // Handle saving edits
    const handleSaveEdit = () => {
        if (!editTitle.trim() || !editGuidelines.trim()) {
            notify("warning", `Both title and guidelines are required.`);
            alert("Both title and guidelines are required.");
            return;
        }
        axios
            .post(
                "https://docuquest-swu.swucite.tech/api_drts/documentGuidelines.php",
                { id: editingId, title: editTitle, guidelines: editGuidelines },
                { headers: { "Content-Type": "application/json" } }
            )
            .then((response) => {
                if (response.data.status === "success") {
                    setEntries((prevEntries) =>
                        prevEntries.map((entry) =>
                            entry.id === editingId ? { ...entry, title: editTitle, guidelines: editGuidelines } : entry
                        )
                    );
                    
                    setEditingId(null);
                    notify("success", `Updated ${editTitle} successfully.`);
                    
                    const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `Edited entry: ${editTitle}`,
                        name_action: "Guidlines&Policy Edit",
                        status_action: `Entry edited by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 0.5,
                        score_prod: 0.7
                    })
                    .then(() => {
                                    
                    })
                    .catch((err) => {

                    }) 
                    
                    alert("Entry updated successfully.");
                } else {
                    notify("error", `Failed to update ${editTitle}.` + response.data.message);
                    alert("Failed to update entry: " + response.data.message);
                }
            })
            .catch((error) => {
                //console.error("Error updating entry:", error);
                alert("Error updating entry. Check console for details.");
            });
    };

   // Handle deleting an entry
   const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this entry?")) {
        return;
    }
    axios
        .delete("https://docuquest-swu.swucite.tech/api_drts/documentGuidelines.php", {
            data: { id }, // Send `id` in the request body
            headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
            if (response.data.status === "success") {
                setEntries(entries.filter((entry) => entry.id !== id));
                
                const today = new Date();

                axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                    updated_by: userIdRef.current,
                    updated_date: formatToSQLDateTime(today),
                    created_by: userIdRef.current,
                    created_date: formatToSQLDateTime(today),
                    feedback: `Entry ${id} deleted`,
                    name_action: "Documents&Guidelines Delete",
                    status_action: `Entry deleted by ${userNameRef.current}`,
                    stage_now: 1,
                    stage_max: 1,
                    score_eff: 0.3,
                    score_prod: 0.5
                })
                .then(() => {
                                
                })
                .catch((err) => {
            
                })   
                
                alert("Entry deleted successfully.");
            } else {
                alert("Failed to delete entry: " + response.data.message);
            }
        })
        .catch((error) => {
            //console.error("Error deleting entry:", error);
            alert("Error deleting entry. Check console for details.");
        });
    };

    const handleSaveNote = async () => {
        if (!note.trim()) {
            notify("warning", `Note cannot be empty.`);
            setError("Note cannot be empty.");
            return;
        }
        try {
            const response = await axios.post(
                "https://docuquest-swu.swucite.tech/api_drts/note.php",
                { note },
                { headers: { "Content-Type": "application/json" } }
            );
            if (response.data.status === "success") {
                setIsEditing(false);
                notify("success", `Note saved successfully!`);
                setSuccessMessage("Note saved successfully!");

                const today = new Date();

                axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                    updated_by: userIdRef.current,
                    updated_date: formatToSQLDateTime(today),
                    created_by: userIdRef.current,
                    created_date: formatToSQLDateTime(today),
                    feedback: `New note saved`,
                    name_action: "Note edited",
                    status_action: `Note edited by ${userNameRef.current}`,
                    stage_now: 1,
                    stage_max: 1,
                    score_eff: 0.5,
                    score_prod: 0.7
                })
                .then(() => {
                                
                })
                .catch((err) => {
            
                })   

                setError(null);
            } else {
                setError(response.data.message);
            }
        } catch (error) {
            setError("Error saving note. Please check the console for details.");
            //console.error(error);
        }
    };

    
    // Handle saving edited guidelines
    // const handleSaveGuidelines = () => {
    //     if (!guidelines.trim()) {
    //         console.error("Guidelines cannot be empty.");
    //         alert("Please provide valid guidelines before saving.");
    //         return;
    //     }
    
    //     axios
    //         .post("https://docuquest-swu.swucite.tech/api_drts/documentGuidelines.php", 
    //             { guidelines }, 
    //             { headers: { "Content-Type": "application/json" } }
    //         )
    //         .then((response) => {
    //             if (response.data.status === "success") {
    //                 setIsEditingGuidelines(false);
    //                 console.log("Guidelines updated successfully.");
    //                 alert("Guidelines saved successfully.");
    //             } else {
    //                 console.error("Failed to save guidelines:", response.data.message);
    //                 alert("Failed to save guidelines: " + response.data.message);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("Error saving guidelines:", error);
    //             alert("Error saving guidelines. Please check the console for details.");
    //         });
    // };


    // Fetch shipping fees from the backend
    const fetchShippingFees = () => {
        axios.get('https://docuquest-swu.swucite.tech/api_drts/shippingFee.php') // Your backend API endpoint
            .then((response) => {
                // Assuming response is an array of objects with region and fee properties
                const fees = response.data.reduce((acc, fee) => {
                    acc[fee.region] = fee.fee;
                    return acc;
                }, {});
                setShippingFees(fees);
            })
            .catch((error) => {
                setErrorFees({
                    type:"danger",
                    message: `Error fetching shipping fees: ${error.response ? error.response.data : error.message}`
                })
            });
    };

    // Fetch documents from the backend on component mount
    useEffect(() => {
        // get document types
        axios.get('https://docuquest-swu.swucite.tech/api_drts/cmsDocs.php')
            .then((response) => {
                const gotCategories = response.data;
                setDocuments(gotCategories);
                fetchShippingFees();
            })
            .catch((error) => {
                setErrorDocuments({
                    type:"danger",
                    message: `Error fetching documents: ${error}`
                })
            });

        // get shipping fees for delivery
        // https://docuquest-swu.swucite.tech/api_drts/shippingFee.php
        axios.get('https://docuquest-swu.swucite.tech/api_drts/shippingFee.php')
            .then((response) => {
                //console.log(response.data); // Check the response here
                setShippingFees({
                    Luzon: response.data.luzon_price,
                    Visayas: response.data.visayas_price,
                    Mindanao: response.data.mindanao_price
                });
                //console.warn('shipping fees got: ', shippingFees)
            })
            .catch((error) => {
                setErrorFees({
                    type:"danger",
                    message: `Error fetching shipping fees: ${error}`
                })
            });

        // console.log("got documents: ", documents)
        // console.log("got shipping fees: ", shippingFees)
    }, []);

    // TODO
    const getUserEmail = () => {
        let accountId = parseInt(userIdRef.current, 10);
    
        // Return the axios promise
        return axios
            .get(`https://docuquest-swu.swucite.tech/api_drts/users.php/${accountId}/`)
            .then((res) => {
                if (res.data && res.data.email) {
                    return res.data.email; // Return the email from the response
                } else {
                    throw new Error("Email not found for the given account ID");
                }
            })
            .catch((err) => {
                //console.error("Error fetching user email:", err);
                throw err; // Propagate the error
            });
    };
    
    // TODO if sending email_staff, refer to chatgpt chat "request form calculating algorithm"
    
    const validateDocumentName = (name) => {
        // Check if the name is empty
        if (!name.trim()) {
            return {
                isValid: false,
                message: "Document name cannot be empty"
            };
        }
        
        // This is for Valitaion of the documents
        // Check for duplicates (case-insensitive)
        const isDuplicate = documents.some(
            doc => doc.name.toLowerCase() === name.toLowerCase()
        );
    
        if (isDuplicate) {
            return {
                isValid: false,
                message: `Document "${name}" already exists (case-insensitive comparison)`
            };
        }
    
        return {
            isValid: true,
            message: ""
        };
    };

    // Add a new document
    const handleAddDocument = () => {
        const validation = validateDocumentName(newDocument.name);

        if (!validation.isValid) {
            notify("error", validation.message);
            setErrorCMS({
                type: "danger",
                message: validation.message
            });
            return;
        }

        if (newDocument.name && newDocument.price && newDocument.processingDays && newDocument.pages) {
            notify("success", `New document created`);

            axios.post('https://docuquest-swu.swucite.tech/api_drts/categoryDocs.php', {
                name: newDocument.name,
                price: newDocument.price,
                processing_days: newDocument.processingDays,
                pages: newDocument.pages,
                luzon_price: newDocument.luzon_price,
                visayas_price: newDocument.visayas_price,
                mindanao_price: newDocument.mindanao_price,
                // email_staff: getUserEmail(),
            })
            .then((response) => {
                // Refetch the documents list
                //console.warn(response);

                axios.get('https://docuquest-swu.swucite.tech/api_drts/categoryDocs.php')
                .then((response) => setDocuments(response.data))
                .catch((error) => {
                  setErrorCMS({
                    type: "danger",
                    message: error
                  });
                });

                const today = new Date();

                axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                    updated_by: userIdRef.current,
                    updated_date: formatToSQLDateTime(today),
                    created_by: userIdRef.current,
                    created_date: formatToSQLDateTime(today),
                    feedback: `New document: ${newDocument.name}`,
                    name_action: "Document Add",
                    status_action: `Document added by ${userNameRef.current}`,
                    stage_now: 1,
                    stage_max: 1,
                    score_eff: 0.5,
                    score_prod: 0.7
                })
                .then(() => {
                    
                })
                .catch((err) => {

                }) 

                setNewDocument({ name: '', price: '', processingDays: '', pages: '', luzon_price: '', visayas_price: '', mindanao_price: ''}); // Reset form
            })
            .catch((error) => {
                setErrorCMS({
                    type: "danger",
                    message: `Error adding document category "${newDocument.name}": ${error}`
                  });
            });
        }
    };

     // Toggle visibility of a document
     const handleToggleDocumentVisibility = (index) => {
        const updatedDocuments = [...documents];
        updatedDocuments[index].hidden = !updatedDocuments[index].hidden;
        setDocuments(updatedDocuments);
    
        //console.log("Updating document visibility:", updatedDocuments[index]);
    
        // Send the update request to the backend
        axios
            .patch(`https://docuquest-swu.swucite.tech/api_drts/categoryDocs.php/${updatedDocuments[index].id}`, {
                name: updatedDocuments[index].name,
                price: updatedDocuments[index].price,
                processing_days: updatedDocuments[index].processing_days,
                pages: updatedDocuments[index].pages,
                luzon_price: updatedDocuments[index].luzon_price,
                visayas_price: updatedDocuments[index].visayas_price,
                mindanao_price: updatedDocuments[index].mindanao_price,
                hidden: updatedDocuments[index].hidden, // Send hidden status
            })
            .then((response) => {
                notify("success", `\"${updatedDocuments[index].name}\" visibility updated: ${!updatedDocuments[index].hidden}`);
                // console.log("PATCH hidden Response:", response.data);
                
                const today = new Date();

                axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                    updated_by: userIdRef.current,
                    updated_date: formatToSQLDateTime(today),
                    created_by: userIdRef.current,
                    created_date: formatToSQLDateTime(today),
                    feedback: `Hide/Unhide document: ${updatedDocuments[index].name}, Visibility: ${!updatedDocuments[index].hidden}`,
                    name_action: "Document Hide/Unhide",
                    status_action: `Document edited by ${userNameRef.current}`,
                    stage_now: 1,
                    stage_max: 1,
                    score_eff: 0.5,
                    score_prod: 0.5
                })
                .then(() => {
                    
                })
                .catch((err) => {

                })  

                if (response.data.status !== 1) {
                    notify("error", `Error updating visibility: ` + (response.data.message || "Unknown error"));
                    // alert("Error updating visibility: " + (response.data.message || "Unknown error"));
                }
            })
            .catch((error) => {
                //console.error("Error updating visibility:", error);
                alert("Error updating visibility. Check console for details.");
            });
    };

    // Update the shipping fee and persist it to the backend
    const handleUpdateShippingFees = () => {
        // Update the local state with the new fee
        //const updatedShippingFees = { ...shippingFees, [region]: fee };
        // setShippingFees(updatedShippingFees);

        // Send the updated shipping fee to the backend
        axios.post('https://docuquest-swu.swucite.tech/api_drts/shippingFee.php', shippingFees)
        .then((response) => {
            if (response.data.status === 'success') {
                setErrorFees({
                    type:"success",
                    message: `Shipping fee updated successfully: ${response.data.message}`
                })

                // Fetch the latest shipping fees after successful update
                axios.get('https://docuquest-swu.swucite.tech/api_drts/shippingFee.php')
                .then((response) => {
                    setShippingFees(response.data); // Set the updated shipping fees
                })
                .catch((error) => {
                    setErrorFees({
                        type: "danger",
                        message: `Error fetching updated shipping fees: ${error.response ? error.response.data : error.message}`
                    });
                });
            } else {
                setErrorFees({
                    type: "danger",
                    message: `ERROR! Failed to save shipping fees: ${response.data.message}`
                });
            }
        })
        .catch((error) => {
            //console.error("Error during POST request:", error);

            setErrorFees({
                type: "danger",
                message: `ERROR! Failed to save shipping fees: ${error.response ? error.response.data : error.message}`
            });
        });
    };

    const [editDocument, setEditDocument] = useState(null); // Holds the document being edited
    
    // Function to handle editing a document
    const handleEditDocument = (index) => {
        const documentToEdit = documents[index];
        setEditDocument({ ...documentToEdit, index, processingDays: documentToEdit.processing_days, }); // Save the document and its index
    };

    const handleSaveEditDocument = () => {
        // Check if the name was changed; prevent duplicates in editing
        const originalDoc = documents[editDocument.index];
        const nameChanged = editDocument.name.toLowerCase() !== originalDoc.name.toLowerCase();

        const oldName = originalDoc.name;
        const oldProcessing = parseInt(originalDoc.processing_days, 10);
        const oldPages = parseInt(originalDoc.pages, 10) ;
        const oldPrice = originalDoc.price;
        const oldMultipurpose = originalDoc.multi_purpose === 1 ? "Enabled" : "Disabled";

        if (nameChanged) {
            const validation = validateDocumentName(editDocument.name);
            if (!validation.isValid) {
                notify("error", validation.message);
                setErrorCMS({
                    type: "danger",
                    message: validation.message
                });
                return;
            }
        }

        axios
            .patch(`https://docuquest-swu.swucite.tech/api_drts/categoryDocs.php/${editDocument.id}`, {
                name: editDocument.name,
                price: editDocument.price,
                processing_days: parseInt(editDocument.processingDays, 10),
                pages: parseInt(editDocument.pages, 10), 
                luzon_price: editDocument.luzon_price,
                visayas_price: editDocument.visayas_price,
                mindanao_price: editDocument.mindanao_price,
                multi_purpose: editDocument.multi_purpose,
            })
            .then((response) => {
                if (response.data.status === 1) {
                    // Update the documents list locally
                    const updatedDocuments = [...documents];
                    updatedDocuments[editDocument.index] = {
                        ...editDocument,
                        processing_days: parseInt(editDocument.processingDays, 10),
                        hidden: documents[editDocument.index].hidden, // Preserve visibility state
                    };
                    setDocuments(updatedDocuments);
                    setEditDocument(null); // Exit edit mode

                    const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `Edit document: ${newDocument.name}`,
                        name_action: "Document Edit",
                        status_action: `Document edited by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 0.5,
                        score_prod: 0.5
                    })
                    .then(() => {
                        
                    })
                    .catch((err) => {
    
                    })   

                    notify("success", `Saved changes to ${oldName} as ${editDocument.name}`);
                } else {
                    notify("error", `Error saving document changes: ${response.data.message}`);
                    setErrorCMS({
                        type: "danger",
                        message: `Error saving document changes: ${response.data.message}`,
                    });
                }
            })
            .catch((error) => {
                
                setErrorCMS({
                    type: "danger",
                    message: `Error saving document changes: ${
                        error.response ? error.response.data : error.message
                    }`,
                });
            });
    };

    // Handle region selection for shipping fee
    const handleRegionChange = (e) => {
        setSelectedRegion(e.target.value);
    };
    // Handle shipping fee change based on region
    const handleShippingFeeChange = (e) => {
        setShippingFees({
            ...shippingFees,
            [selectedRegion]: e.target.value
        });
    };

    const handleSaveShippingFees = async () => {
        try {
            // Save shipping fees to the database
            const saveResponse = await axios.post('https://docuquest-swu.swucite.tech/api_drts/shippingFee.php', {
                region: selectedRegion,
                fee: shippingFees[selectedRegion]
            });
    
            notify("success", `Updated shipping fee of ${selectedRegion} to ${shippingFees[selectedRegion]}`);
            setErrorFees({
                type: "success",
                message: `${saveResponse.data.message}`
            });
    
            // Re-fetch the updated shipping fees
            const fetchResponse = await axios.get('https://docuquest-swu.swucite.tech/api_drts/shippingFee.php');
            const updatedShippingFees = fetchResponse.data;

            setShippingFees(updatedShippingFees); // Update state with the fetched data
    
            if (updatedShippingFees[selectedRegion]) {
                setShippingFees((prevFees) => ({
                    ...prevFees,
                    [selectedRegion]: updatedShippingFees[selectedRegion],
                }));
            }

            const today = new Date();

            axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                updated_by: userIdRef.current,
                updated_date: formatToSQLDateTime(today),
                created_by: userIdRef.current,
                created_date: formatToSQLDateTime(today),
                feedback: `Region: ${selectedRegion}, Shipping Fee ${shippingFees[selectedRegion]}`,
                name_action: "Update Shipping Fees",
                status_action: `Shipping Fees edited by ${userNameRef.current}`,
                stage_now: 1,
                stage_max: 1,
                score_eff: 0.5,
                score_prod: 0.7
            })
            .then(() => {
                            
            })
            .catch((err) => {

            })

        } catch (error) {
            setErrorFees({
                type: "danger",
                message: `ERROR! Cannot save shipping fees: ${error.response ? error.response.data : error.message}`
            });
        }
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'Profile':
                return (<div>
                    <h3>Profile Settings</h3>
                    
                    </div>);
            case 'Account':
                return (<div>
                    <h3>My Account</h3>
                    
                    </div>);      
            case 'ADD DOCUMENT':    
                return (
                    <div className="cms-content">
                        <h3>Add Document</h3>
                        {errorCMS ? (
                          <Alert variant={errorCMS.type}>
                            {errorCMS.message}
                          </Alert>
                        ) : ""
                        }
                        <div className="add-document">
                            <h4>All fields below are required.</h4>
                            <div className="form-group">
                                <label htmlFor="documentName">Document Name</label>
                                <input
                                    id="documentName"
                                    type="text"
                                    placeholder="Document Name"
                                    value={newDocument.name}
                                    onChange={(e) => {
                                        const name = e.target.value;
                                        setNewDocument({ ...newDocument, name });
                                        
                                        // Real-time validation
                                        if (name.trim()) {
                                            const validation = validateDocumentName(name);
                                            if (!validation.isValid) {
                                                setErrorCMS({
                                                    type: "warning",
                                                    message: validation.message
                                                });
                                            } else {
                                                setErrorCMS({
                                                    type: "",
                                                    message: ""
                                                });
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="price">Price (Philippine Peso)</label>
                                <input
                                    id="price"
                                    type="number"
                                    min={1}
                                    max={9999}
                                    placeholder="Price (Philippine Peso)"
                                    value={newDocument.price}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || parseInt(value) > 0) {
                                            setNewDocument({ ...newDocument, price: value });
                                        } else {
                                            // Clear the value if 0 or invalid input is entered
                                            setNewDocument({ ...newDocument, price: '' });
                                        }
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="processingDays">Processing Days</label>
                                <input
                                    id="processingDays"
                                    type="number"
                                    placeholder="Processing Days"
                                    min={1}
                                    max={9999}
                                    value={newDocument.processingDays}
                                    onChange={(e) => setNewDocument({ ...newDocument, processingDays: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label>Number of Pages</label>
                                <input
                                    type="number"
                                    min={1}
                                    placeholder="Pages"
                                    value={newDocument.pages}
                                    onChange={(e) => setNewDocument({ ...newDocument, pages: e.target.value })}
                                />
                            </div>                                
                                <button
                                    onClick={handleAddDocument}
                                    disabled={
                                        !newDocument.name ||
                                        !newDocument.price ||
                                        parseInt(newDocument.price) <= 0 ||
                                        !newDocument.pages ||
                                        !newDocument.processingDays
                                    }
                                >
                                    Add Document
                                </button>
                        </div>
                        <div className="document-table">
                            <h4>Existing Documents</h4>
                            {errorDocuments ? (
                              <Alert variant={errorDocuments.type}>
                                {errorDocuments.message}
                              </Alert>
                            ) : ""
                            }
                            <table>
                                <thead>
                                    <tr>
                                        <th>Document Name</th>
                                        <th>Processing Days</th>
                                        <th>Number of Pages</th>
                                        <th>Base Price (₱)</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {documents.map((doc, index) => (
                                    <tr key={index}>
                                        <td>
                                            {editDocument && editDocument.index === index ? (
                                                <input
                                                    type="text"
                                                    value={editDocument.name}
                                                    onChange={(e) =>
                                                        setEditDocument({ ...editDocument, name: e.target.value })
                                                    }
                                                />
                                            ) : (
                                                doc.name
                                            )}
                                        </td>
                                        <td>
                                            {editDocument && editDocument.index === index ? (
                                                <input
                                                    type="number"
                                                    min={1}
                                                    value={editDocument.processingDays}
                                                    onChange={(e) =>
                                                        setEditDocument({ ...editDocument, processingDays: e.target.value })
                                                    }
                                                />
                                            ) : (
                                                doc.processing_days
                                            )}
                                        </td>
                                        <td>
                                            {editDocument && editDocument.index === index ? (
                                                <input
                                                    type="number"
                                                    min={1}
                                                    value={editDocument.pages}
                                                    onChange={(e) =>
                                                        setEditDocument({ ...editDocument, pages: e.target.value })
                                                    }
                                                />
                                            ) : (
                                                doc.pages
                                            )}
                                        </td>
                                        <td>
                                            {editDocument && editDocument.index === index ? (
                                                <input
                                                    type="number"
                                                    min={1}
                                                    value={editDocument.price}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === '' || parseInt(value) > 0) {
                                                            setEditDocument({ ...editDocument, price: value });
                                                        } else {
                                                            // Prevent 0 or invalid input
                                                            setEditDocument({ ...editDocument, price: '' });
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                doc.price
                                            )}
                                        </td>
                                        <td>
                                        {editDocument && editDocument.index === index ? (
                                            <label>
                                            <input
                                                type="checkbox"
                                                checked={editDocument.multi_purpose === 1} // Added this checkbox
                                                onChange={(e) =>
                                                setEditDocument({
                                                    ...editDocument,
                                                    multi_purpose: e.target.checked ? 1 : 0, // Toggle between 1 and 0
                                                })
                                                }
                                            />
                                            {editDocument.multi_purpose === 1 ? "Enabled" : "Disabled"}
                                            </label>
                                        ) : (
                                            doc.multi_purpose === 1 ? "Enabled" : "Disabled" // Display current state
                                        )}
                                        </td>
                                        <td>
                                            {editDocument && editDocument.index === index ? (
                                                <button onClick={handleSaveEditDocument}>Save</button>
                                            ) : (
                                                <>
                                                    <button onClick={() => handleEditDocument(index)}>Edit</button>
                                                    <button onClick={() => handleToggleDocumentVisibility(index)}>
                                                        {doc.hidden ? 'Unhide' : 'Hide'}
                                                    </button>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>       
                    </div>
                    );          
            
            case 'ADD NOTE':
                return (<div>
                    {/* <h3>Note Management</h3> */}
                        <div className="note-manager">
                          <h3>Note Management</h3>
                          {error && <Alert variant="danger">{error}</Alert>}
                          {successMessage && <Alert variant="success">{successMessage}</Alert>}
                            <div className="note-box">
                                {isEditing ? (
                                    <textarea
                                        value={note}
                                        onChange={(e) => setNote(e.target.value)}
                                        rows={4}
                                        cols={50}
                                        placeholder="Enter your note here..."
                                    />
                                ) : (
                                    <p>{note || "No note available."}</p>
                                )}
                            </div>
                            <div className="note-actions">
                                {isEditing ? (
                                    <button onClick={handleSaveNote}>Save</button>
                                ) : (
                                    <button onClick={() => setIsEditing(true)}>Edit</button>
                                )}
                            </div>
                        </div> 
                    </div>);

            case 'ADD COURSE':
                return (<div>
                        <div>
                            <h4>Add Course</h4>
                            {errorCourse && <Alert variant="danger">{errorCourse}</Alert>}
                            <div className="add-course">
                                <input
                                    type="text"
                                    value={newCourse}
                                    placeholder="Enter course name"
                                    onChange={(e) => setNewCourse(e.target.value)}
                                />
                                <button onClick={handleAddCourse}>Add Course</button>
                            </div>
                            <div className="courses-list">
                                <h4>Available Courses</h4>
                                <ul>
                                    {courses.map((course) => (
                                        <li key={course.id}>
                                            {course.course_name}
                                            <button onClick={() => handleDeleteCourse(course.id)}>Delete</button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>);

            case 'UPDATE SHIPPING':
                return (<div>
                        <div className="shipping-fee">
                            <h4>Update Shipping Fee</h4>
                            {errorFees ? (
                              <Alert variant={errorFees.type}>
                                {errorFees.message}
                              </Alert>
                            ) : ""
                            }
                            <div className="center-container">
                                <label>Select Region:</label>
                                <select value={selectedRegion} onChange={handleRegionChange} disabled={!isEditable}>
                                    <option value="Luzon">Luzon</option>
                                    <option value="Visayas">Visayas</option>
                                    <option value="Mindanao">Mindanao</option>
                                </select>
                            </div>

                            <div className="center-container">
                                <label>Shipping Fee (₱)</label>
                                <input
                                type="number"
                                min={1}
                                value={shippingFees[selectedRegion]}
                                onChange={handleShippingFeeChange}
                                placeholder={`Shipping Fee for ${selectedRegion} (₱)`}
                                disabled={!isEditable}
                                /> 
                            </div>  

                            <div className="button-group">
                                {/* Toggle button to enable/disable editing */}
                                <button onClick={toggleEditable} className="action-button">
                                    {isEditable ? "Disable Edit" : "Enable Edit"}
                                </button>
                                <button onClick={handleSaveShippingFees} className="action-button" disabled={!isEditable}>
                                    Save
                                </button>
                            </div>

                            
                            {/* <br></br>
                            <br></br> */}

                            {/* Delivery Toggle Section */}
                            <div className="center-container">
                                <label>Delivery:</label>
                                <button onClick={toggleDelivery} className="action-button">
                                {isDeliveryEnabled ? "Disable Delivery" : "Enable Delivery"}
                                </button>
                            </div>
                        </div>                    
                    </div>);

            case 'GUIDELINES & POLICIES':
                return (<div>
                        <div className="document-guidelines">
                            <h4>Document Protocol Guidelines and Policy</h4>
                            {entries.map((entry) =>
                                editingId === entry.id ? (
                                    <div key={entry.id} style={{ marginBottom: "20px" }}>
                                        <input
                                            type="text"
                                            value={editTitle}
                                            onChange={(e) => setEditTitle(e.target.value)}
                                            placeholder="Enter title"
                                            style={{ width: "100%", marginBottom: "10px" }}
                                        />
                                        <textarea
                                            value={editGuidelines}
                                            onChange={(e) => setEditGuidelines(e.target.value)}
                                            rows={4}
                                            cols={50}
                                            placeholder="Enter guidelines here..."
                                        />
                                        <br />
                                        <button className="save-button" onClick={handleSaveEdit}>Save</button>
                                        <button className="cancel-button" onClick={() => setEditingId(null)}>Cancel</button>
                                    </div>
                                ) : (
                                    <div key={entry.id} style={{ marginBottom: "20px" }}>
                                        <h5>{entry.title}</h5>
                                        <p>{entry.guidelines}</p>
                                        <small>Added on: {new Date(entry.created_at).toLocaleString()}</small>
                                        <br />
                                        <button className="edit-button" onClick={() => handleEdit(entry)}>Edit</button>
                                        <button className="delete-button" onClick={() => handleDelete(entry.id)}>Delete</button>
                                    </div>
                                )
                            )}
                            <hr />
                            <h5>Add New Entry</h5>
                            <input
                                type="text"
                                value={newTitle}
                                onChange={(e) => setNewTitle(e.target.value)}
                                placeholder="Enter title"
                                style={{ width: "100%", marginBottom: "10px" }}
                            />
                            <textarea
                                value={newGuidelines}
                                onChange={(e) => setNewGuidelines(e.target.value)}
                                rows={4}
                                cols={50}
                                placeholder="Enter guidelines here..."
                            />
                            <br />
                            <button className="add-entry" onClick={handleAddEntry}>Add Entry</button>
                        </div>
                    </div>);

            case 'Security':
                return (<div>
                    <h3>Security</h3>
                    
                    </div>);
            case 'Notifications':
                return (<div>
                    <h3>Notifications</h3>
                    
                    </div>);
            case 'Privacy':
                return (<div>
                    <h3>Privacy</h3>
                    
                    </div>);

            default:
                return (<div>
                    Select an option from the menu
                    
                    </div>);
        }
    };

    return (
        <div className="settings-container">
            <div className="sidebar">
                <h2>Settings</h2>
                <ul className="menu">
                    {/* <li onClick={() => setSelectedOption('Profile')}>Profile</li>
                    <li onClick={() => setSelectedOption('Security')}>Security</li> */}
                    {/* <li onClick={() => setSelectedOption('Notifications')}>Notifications</li> */}
                    {/* <li onClick={() => setSelectedOption('Privacy')}>Privacy</li>
                    <li onClick={() => setSelectedOption('Account')}>Account</li> */}
                    <li onClick={() => setSelectedOption('ADD DOCUMENT')}>ADD DOCUMENT</li>
                    <li onClick={() => setSelectedOption('UPDATE SHIPPING')}>UPDATE SHIPPING</li>
                    <li onClick={() => setSelectedOption('GUIDELINES & POLICIES')}>GUIDELINES & POLICIES</li>
                    <li onClick={() => setSelectedOption('ADD NOTE')}>ADD NOTE</li>
                    <li onClick={() => setSelectedOption('ADD COURSE')}>ADD COURSE</li>
                </ul>
            </div>
            <div className="content">
                {renderContent()}
            </div>

            <ToastContainer newestOnTop/>
        </div>
    );
}